import React from 'react'
import DataSource from '../DataSource'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import PremiumSmsForm from '../forms/PremiumSmsForm'
import PaymentInformation from './PaymentInformation'
import globals from '../globals'

class PremiumSms extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            fields: {}
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getPremiumSmsData/${this.props.serviceId}`, result => {
            this.setState(result)
            this.setState({ isLoaded: true })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleSuccess (response, state) {
	    globals.pushEvent('MobileUpdatePremiumSms', {
            active: state.active,
            spendLimit: state.spendLimit
        })
    }

    render () {
        return (
            <div>
                <div className='buy-usage-data module' style={{ overflow: 'visible' }}>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2 text-center text-md-left'>
                                <p>You can limit access and spend levels on Premium SMS content on your mobile service here.</p>
                                <p>Premium SMS services are information, entertainment services or downloads for your mobile phone. Examples of Premium SMS services are competition lines, voting lines, ringtones, wallpapers and video content.</p>
                                <p>Premium SMS services are provided by third-party organisations, not by Exetel. Premium SMS providers can charge a fee-for-use or recurring subscription which is charged to your Exetel mobile account. These services attract premium fees and are charged over and above your mobile plan’s message allowance.</p>
                                <p>Please note that it takes 1 business day to de-activate Premium SMS on your mobile service.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <PremiumSmsForm
                                    serviceId={this.props.serviceId}
                                    fields={this.state.fields}
                                    handleSuccess={this.handleSuccess.bind(this)}
                                />
                            </div>
                        </div>
                    </ModuleWithLoader>
                </div>
                <PaymentInformation />
            </div>
        )
    }
}

export default PremiumSms



// WEBPACK FOOTER //
// ./resources/js/modules/PremiumSms.js